import { render } from "./Main.vue?vue&type=template&id=130ebe72&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=130ebe72&scoped=true&lang=css"

import exportComponent from "D:\\workspace_front\\github\\spinner-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130ebe72"]])

export default __exports__